export * from './lib/checkbox-input.component.module';
export { AccredibleCheckboxInputComponent } from './lib/checkbox-input.component';
